import { render, staticRenderFns } from "./KoioteBombCanvasQuesos.vue?vue&type=template&id=7e48dd53&scoped=true"
import script from "./KoioteBombCanvasQuesos.vue?vue&type=script&lang=js"
export * from "./KoioteBombCanvasQuesos.vue?vue&type=script&lang=js"
import style0 from "./KoioteBombCanvasQuesos.vue?vue&type=style&index=0&id=7e48dd53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e48dd53",
  null
  
)

export default component.exports